import {
    buildAddLayerMapping,
    buildMoveLayerMapping,
    buildRemoveLayerMapping,
} from "@app/common/components/viewers/configurator/extensions/bd-cloud/helpers/layers"

export type AccessoryStackEntry = {
    accessoryId: number
    stackId: string
    inputParameterIds: string[]
    type: string
}

type AccessoryMapping = {
    mapping: Map<number, number>
    newCount: number
}

export class AccessoryStack {
    readonly entries: readonly AccessoryStackEntry[]
    private readonly reversed: boolean

    constructor(entries: AccessoryStackEntry[], reversed: boolean) {
        this.entries = [...entries].sort((a, b) => a.accessoryId - b.accessoryId)
        this.reversed = reversed
    }

    get entryCount(): number {
        return this.entries.length
    }

    getDisplayEntries(): readonly AccessoryStackEntry[] {
        return this.reversed ? [...this.entries].reverse() : this.entries
    }

    buildAddMapping(): AccessoryMapping {
        return {
            mapping: buildAddLayerMapping(this.entryCount, this.entryCount),
            newCount: this.entryCount + 1,
        }
    }

    buildRemoveMapping(displayIndex: number): AccessoryMapping {
        const templateIndex = this.displayIndexToTemplateIndex(displayIndex)
        return {
            mapping: buildRemoveLayerMapping(this.entryCount, templateIndex),
            newCount: this.entryCount - 1,
        }
    }

    buildMoveMapping(displaySourceIndex: number, displayTargetIndex: number): AccessoryMapping {
        const templateSource = this.displayIndexToTemplateIndex(displaySourceIndex)
        const templateTarget = this.displayIndexToTemplateIndex(displayTargetIndex)
        return {
            mapping: buildMoveLayerMapping(this.entryCount, templateSource, templateTarget),
            newCount: this.entryCount,
        }
    }

    canMove(displaySourceIndex: number, displayTargetIndex: number): boolean {
        return (
            displaySourceIndex !== displayTargetIndex &&
            displaySourceIndex >= 0 &&
            displaySourceIndex < this.entryCount &&
            displayTargetIndex >= 0 &&
            displayTargetIndex < this.entryCount
        )
    }

    private displayIndexToTemplateIndex(displayIndex: number): number {
        if (!this.reversed) return displayIndex
        return this.entryCount - 1 - displayIndex
    }
}
